export default __webpack_public_path__ + "static/media/folder_icon.5badfccf.svg";